import { IResourceComponentsProps } from "@pankod/refine-core"

export const CustomizableContentShow: React.FC<IResourceComponentsProps> = () => {
    return (
        <></>
    )
}